import { ref, push, set } from "firebase/database";
import { auth, db } from "../services/firebase";

export default function useSaveReview() {
    const saveReview = async (review) => {
        const user = auth.currentUser;
        if (!user) throw new Error("User not logged in");

        // Reference to user's review list
        const userReviewsRef = ref(db, `Others/Reviews/${user.uid}`);

        // Create new auto-generated ID
        const newReviewRef = push(userReviewsRef);

        // Save review inside that auto-ID
        await set(newReviewRef, {
            ...review,
            reviewId: newReviewRef.key,   // include ID in data
            createdAt: Date.now(),
        });
    };

    return { saveReview };
}
